export default __webpack_public_path__ + "images/6cec86784351ab6260c1d54ebc91bf20-dcj.png";